export default {
  dashboard: '儀表盤',
  // introduction: 'Introduction',
  documentation: '文檔',
  guide: '導引',
  roadmap: '線路圖',
  i18n: '國際化',
  theme: '主題',
  // pagePermission: 'Page Permission',
  // rolePermission: 'Role Permission',
  permissions: '權限',
  permission: {
    admin: '管理員',
    editor: '編輯者',
    visitor: '訪客',
  },
  components: '組件',
  component: {
    avatarUpload: '上傳頭像',
    backToTop: '回到頂部',
    countTo: '累加器',
    dragKanban: '可拖動看板',
    dropzone: 'Dropzone',
    jsonEditor: 'Json編輯器',
    markdown: 'Markdown',
    splitPane: '分隔欄',
    sticky: '黏貼(Sticky)',
    tinymce: '富文本編輯(Tinymce)',
  },
  vuetify: 'Vuetify UI',
  vuetifyComponents: {
    /* There might be some different names of each component in this section,
    so the original English name of each component is reserved. */
    components: '組件/Components',
    alert: '警告/Alert',
    avatar: '頭像/Avatars',
    badge: '徽章/Badges',
    buttons: '按鈕/Buttons',
    calendar: '月曆/Calendar',
    cards: '卡片/Cards',
    carousels: '輪播/Carousels',
    chip: '紙張/Chip',
    colors: '顏色/Colors',
    datepicker: '日期選擇/Datepicker',
    dialogs: '對話框/Dialogs',
    grid: '網格/Grid',
    icon: '圖示/Icons',
    pagination: '分頁/Pagination',
    parallax: '視差/Parallax',
    progress: '進度條/Progress',
    slider: '滑動/Slider',
    snackbar: '消息提示/Snackbar',
    tables: '表格/Tables',
    timepicker: '時間選擇/Timepicker',
    tooltip: '提示信息/Tooltip',
    typography: '版示/Typography',
  },
  errors: '錯誤',
  errorPages: {
    page301: '301',
    page401: '401',
    page403: '403',
    page404: '404',
    page500: '500',
  },
  charts: '圖表',
  chart: {
    keyboardChart: '柱狀圖表',
    lineChart: '曲線圖',
    mixChart: '混合圖表',
  },
  nested: {
    nested: '嵌套',
    nested1: '一級',
    nested2: '二級',
    nested3: '三級',
  },
  clipboard: '剪裁板',
  externalLink: '外部連結',
};
